import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import AuthPage from "../pages/AuthPage";
import MainPage from "../pages/MainPage";
import ReportsPage from "../pages/ReportsPage";
import SettingsPage from "../pages/SettingsPage";
import FactorsReportsPage from "../pages/FactorsReportsPage";
import StatisticReportsPage from "../pages/StatisticReportsPage";
import ComparisonMaps from "../pages/ComparisonMaps";
import DynamicAnalysisPage from "../pages/DynamicAnalysisPage";
import DataModelPage from "../pages/DataModelPage";


export default function AppRouter(){
    return(
        <>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Navigate to="/main_page" replace />} />
                <Route path="/login" element={<AuthPage/>}/>
                <Route path="/main_page" element={<MainPage/>}/>
                <Route path="/comparison_main_page" element={<ComparisonMaps/>}/>
                <Route path="/dynamic_analysis_page" element={<DynamicAnalysisPage/>}/>
                <Route path="/reports_page" element={<ReportsPage/>}/>
                <Route path="/settings_page" element={<SettingsPage/>}/>
                <Route path="/factors_reports_page" element={<FactorsReportsPage/>}/>
                <Route path="/statistic_reports_page" element={<StatisticReportsPage/>}/>
                <Route path="/data-model" element={<DataModelPage/>}/>
                <Route path="*" element={<Navigate to="/main_page" replace />} />
            </Routes>
        </BrowserRouter>
        </>
    )
}
